export const INVOICE_STATUS_OPTIONS = ["pending", "paid", "void", "uncollectable", "all"];

// Every account starts on all pending charges; "Solo cuotas sociales" is opt-in so card
// and match charges are never hidden behind a non-zero balance.
export const defaultFinanceFilters = () => ({
  status: "pending",
  membershipOnly: false,
  includeFuture: false,
  year: "",
  from: "",
  to: "",
});

export const buildInvoiceQuery = (filters, pageSize) => {
  const query = {
    per_page: pageSize,
    include_future: filters.includeFuture ? 1 : 0,
  };
  if (filters.status && filters.status !== "all") query.status = filters.status;
  if (filters.membershipOnly) query.membership = 1;
  if (filters.year) query.year = filters.year;
  if (filters.from) query.from = filters.from;
  if (filters.to) query.to = filters.to;
  return query;
};

export const financeYearOptions = (startYear, now = new Date()) => {
  const current = now.getFullYear();
  const parsedStart = Number(startYear);
  const first = Number.isFinite(parsedStart) && parsedStart > 1900 && parsedStart <= current
    ? parsedStart
    : current - 5;
  const years = [];
  for (let year = current + 1; year >= first; year -= 1) years.push(year);
  return years;
};
